import React, { FC, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { UserState } from '../../state/UserState';
import { useHistory } from 'react-router';
import { SessionState } from '../../state/SessionState';
import * as AuthStore from '../store/AuthStore';
import { Colors } from '../../styles/colors';

const StyledMetaNavigation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const MetaNavigationItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: .75rem;

  cursor: pointer;

  margin: -.5rem 1.5rem -.5rem -.5rem;
  &:last-child {
    margin: -.5rem;
  }
  padding: .5rem;

  & > *:first-child {
    margin-right: .25rem;
  }

  position: relative;
  border: 1px solid transparent;
  border-radius: .5rem .5rem 0 0;
  transition: background-color 150ms ease-out;

  &.active {
    background-color: ${Colors.background};
    border: 1px solid ${Colors.white};
    border-bottom-color: transparent;
  }
`;

const MetaNavigationDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: -1px;     // parent border
  right: -1px;    // parent border
  padding: .5rem .5rem .75rem;

  background-color: ${Colors.background};
  border: 1px solid ${Colors.white};
  border-top-color: transparent;
  border-radius: 0 0 .5rem .5rem;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  transition: opacity 150ms ease-out, transform 150ms ease-out;
  opacity: 0;
  transform-origin: top;
  transform: scaleY(0);
  overflow: hidden;
  pointer-events: none;

  &.active {
    opacity: 1;
    transform: none;
    pointer-events: auto;
  }
`;
const DropdownItem = styled.div`
  padding: .5rem .5rem .5rem 0;
  text-align: end;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  cursor: pointer;
  &:hover {
    @media (pointer: fine) {
      text-decoration: underline;
    }
  }
`;


export interface MetaNavItem {
  title: string;
  onClick: () => void;
}
export interface MetaNavigationProps {
  onSearchClick?: () => void;
  userDropDownItems?: MetaNavItem[];
  interceptLogout?: (continueLogout: () => void) => Promise<boolean>;
}

export const MetaNavigation: FC<MetaNavigationProps> = (props) => {
  const { onSearchClick, userDropDownItems = [], interceptLogout } = props;
  const [user, setUser] = useRecoilState(UserState);
	const setSession = useSetRecoilState(SessionState);
  const history = useHistory();
  const menuItemProfileRef = useRef<HTMLDivElement>(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    const listener = (e: MouseEvent) => {
      if (menuItemProfileRef?.current) {
        const clickInside = menuItemProfileRef.current === e.target || menuItemProfileRef.current.contains(e.target as Node);
        if (!clickInside) {
          setDropdownVisible(false);
        }
      }
    }
    document.addEventListener('click', listener);
    return () => document.removeEventListener('click', listener);
  }, [])

  return (
    <StyledMetaNavigation>
      {
        onSearchClick &&
        <MetaNavigationItem onClick={onSearchClick}>
          <Icon icon={'search'} />
          Kundensuche
        </MetaNavigationItem>
      }
      <MetaNavigationItem ref={menuItemProfileRef} className={dropdownVisible && 'active'} onClick={() => setDropdownVisible(!dropdownVisible)}>
        <Icon icon={'user'} />
        {user?.current?.firstName} {user?.current?.familyName}

        <MetaNavigationDropdown className={dropdownVisible && 'active'}>
          {
            userDropDownItems.map((item, index) => (
              <DropdownItem key={index} onClick={item.onClick}>{ item.title }</DropdownItem>
            ))
          }
          <DropdownItem
            onClick={async () => {
              const logout = () => {
                AuthStore.setSession(null);
                setSession({ current: null });
                setUser({ current: null });

                history.push('/login');
              }

              if (!interceptLogout || await interceptLogout(logout)) {
                logout();
              }
            }}
          >
            Logout
          </DropdownItem>
        </MetaNavigationDropdown>
      </MetaNavigationItem>
    </StyledMetaNavigation>
  );
};
